module.exports = __webpack_public_path__ + "static/media/setting.c63396a6.svg";